import { AnimatedCard } from '@components/ui/3DAnimatedCard';
import { MY_PROJECTS } from '@constants/index';
import { useNavigate } from 'react-router-dom';

const RecentProjects = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col items-center  py-20 text-center">
      <h1 className="font-sans text-lg lg:text-3xl max-w-96 font-bold z-10 ">
        {' '}
        A small selection of my{' '}
        <span className="font-sans text-lg lg:text-3xl max-w-96 font-bold z-10 text-purple">Latest Projects</span>
      </h1>

      <div className="flex flex-wrap gap-16 items-center justify-center p-4 mt-10">
        {MY_PROJECTS.map((project) => (
          <div key={project.id} className="flex flex-col gap-2">
            <AnimatedCard title={project.link} href={project.link}>
              <div className="flex basis-full flex-col p-4 tracking-tight text-slate-100/50 sm:basis-1/2 w-[20rem] h-[20rem] ">
                <h3 className="max-w-xs !pb-2 !m-0 font-bold  text-base text-slate-100">{project.title}</h3>
                <div className="text-base !m-0 !p-0 font-normal">
                  <span className="text-slate-500 ">{project.des}</span>
                </div>
                <img src={project.img} alt={project.title} onClick={() => navigate(`projects/${project.id}`)} />
              </div>
            </AnimatedCard>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentProjects;
